import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=faf9e9d8&scoped=true&"
var script = {}
import style0 from "./not-found.vue?vue&type=style&index=0&id=faf9e9d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf9e9d8",
  null
  
)

export default component.exports